/**
 * Spinning arc icon used to denote an in-progress / pending submission on an
 * order (e.g. the pending state shown in the Auth Status column). The arc rotates
 * continuously via the Tailwind `animate-spin` utility.
 *
 * @param props.width - SVG width (defaults to `12`).
 * @param props.height - SVG height (defaults to `12`).
 * @param props.fill - Fill color for the arc (defaults to blue `#0056D6`).
 * @returns The rendered spinner SVG icon.
 */
const SpinnerIcon = (props: {
  width?: string;
  height?: string;
  fill?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "12"}
    height={props.height || "12"}
    viewBox="0 0 12 12"
    fill="none"
    className="animate-spin"
  >
    <path
      d="M11.8384 7.38324C11.5648 8.53796 10.955 9.58562 10.0859 10.3937C9.21695 11.2019 8.12782 11.7342 6.95631 11.9233C5.78479 12.1124 4.58349 11.9499 3.50433 11.4563C2.42517 10.9627 1.51661 10.1602 0.893547 9.15026C0.270485 8.1403 -0.0390978 6.96826 0.00394884 5.78235C0.0469955 4.59645 0.440738 3.44993 1.13538 2.4878C1.83003 1.52567 2.79438 0.791138 3.90649 0.377081C5.0186 -0.0369762 6.22852 -0.111956 7.38324 0.161622L7.24427 0.748166C6.20556 0.502073 5.11719 0.56952 4.11681 0.941979C3.11643 1.31444 2.24896 1.97518 1.6241 2.84065C0.999241 3.70612 0.645055 4.73745 0.606333 5.80422C0.567611 6.87098 0.846092 7.92528 1.40656 8.83377C1.96703 9.74227 2.78431 10.4642 3.75505 10.9082C4.7258 11.3522 5.80641 11.4984 6.86023 11.3282C7.91406 11.1581 8.89376 10.6793 9.67546 9.95234C10.4572 9.2254 11.0057 8.28299 11.2518 7.24427L11.8384 7.38324Z"
      fill={props.fill || "#0056D6"}
    />
  </svg>
);

export default SpinnerIcon;
